import { deleteRegion, deleteRegionGroup, postRegionGroup, putRegionGroup, regionAtom } from '@/interfaces/region';
import { Button, Card, CircularProgress, Collapse, Typography } from '@mui/material';
import { atom, useAtom, useAtomValue, useSetAtom } from 'jotai';
import styled from 'styled-components';
import AddIcon from '@mui/icons-material/Add';
import { useEffect, useState } from 'react';
import { Region, RegionGroup } from '@/types/regions';
import { CustomTextField } from '../exec/common/CustomMui';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import DeleteIcon from '@mui/icons-material/Delete';
import _ from 'lodash';

const ShippingList = styled(Card)`
    width: 100%;
    height: 100%;
    list-style-type: none;
    padding:0;
    margin:0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .head{
      padding: 0.5rem;
      width: 100%;
      height: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background:rgba(82, 133, 164, 0.87);
      color: #ffffff;
    }
    > .body {
      flex-grow: 1;
      width: 100%;
      height: 100%;
      overflow-y:scroll;
      display: flex;
      flex-direction: column;
    }
    .searchTitle {
      display: grid;
      grid-template-columns: minmax(1rem,auto) 4.5rem;
      align-items: center;
      height: 4rem;
      border-bottom: 1.5px solid #bbb;
      .col{
        width: 100%;
        padding: 0.5rem 0.25rem;
      }
    }
    .listItem{
      border-top: 1px solid #bbb;
    }
    .listItem:first-child{
      border-top:0;
    }
    .listItem:last-child{
      border-bottom: 1.5px solid #bbb;
    }
    .li {
      display: grid;
      grid-template-columns: minmax(1rem,auto) 5rem;
      height: 4rem;
      align-items: center;
      > span {
        display: table-cell;
        height: 2rem;
        line-height: 1rem;
        text-align: center;
        vertical-align: middle;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0.5rem;
        // border-right: 1px solid #bbb;
      }
      > span:first-child{
        text-align:left;
      }
      > span:last-child{
        border:0;
      }
    }
    div > .li:hover, .sub:hover{
      background:rgba(50,50,180,0.1);
    }
    .sub{
      padding: 0 1rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap:0.5rem;
      // grid-template-columns: 2rem minmax(1rem,auto) 5rem 7rem;
      border-top: 0.5px dotted #ccc;
      min-height: 3rem;

    }
    
`;
export const areaListAtom = atom<Region[]>();
export const selectedRegionAtom = atom<number>();
export const hcodeListAtom = atom<string[]>();

export default function RegionList() {
  const { data: regionList, isLoading, refetch } = useAtomValue(regionAtom);
  const setHcodeList = useSetAtom(hcodeListAtom);

  const [contents, setContents] = useState<RegionGroup[]>();
  const [filterName, setFilterName] = useState<string>();
  const [name, setName] = useState<string>();

  useEffect(() => {
    if (regionList && regionList.length > 0) {
      setHcodeList(_.map(_.flatten(_.map(regionList, (v) => v.region)), (x) => x.hcode));
    }
  }, [regionList]);

  useEffect(() => {
    if (regionList && regionList.length > 0) {
      let filterContents = regionList;
      if (filterName && filterName.length > 0) {
        filterContents = _.filter(filterContents, (v) => v.name.indexOf(filterName) > -1);
      }
      setContents(filterContents);
    }
  }, [regionList, filterName]);

  const handleGroupAddClick = async () => {
    await postRegionGroup(name);
    refetch();
  };

  return (
    <ShippingList>
      <div className="head">
        <Typography variant="h6">권역 목록</Typography>
      </div>
      <div className="searchTitle" style={{ display: 'flex' }}>
        <div className="col">
          <CustomTextField
            size="small"
            label="이름"
            fullWidth
            variant="outlined"
            onChange={(e) => setFilterName(e.target.value)}
          />
        </div>
      </div>
      <div className="body">
        {!isLoading &&
          contents &&
          contents.length > 0 &&
          contents.map((item: RegionGroup, index: number) => {
            return <ListItem key={index} item={item} />;
          })}
        {isLoading && (
          <div
            style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <CircularProgress />
          </div>
        )}
        <div className="searchTitle" style={{ borderTop: '1px solid #bbb' }}>
          <div className="col">
            <CustomTextField
              size="small"
              label="이름"
              fullWidth
              variant="outlined"
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="col">
            <Button variant="contained" onClick={() => handleGroupAddClick()}>
              <AddIcon />
            </Button>
          </div>
        </div>
      </div>
    </ShippingList>
  );
}

const ListItem = ({ item }: { item: RegionGroup }) => {
  const [selectedRegion, setSelectedRegion] = useAtom(selectedRegionAtom);
  const setAreaList = useSetAtom(areaListAtom);
  const { refetch } = useAtomValue(regionAtom);

  const [show, setShow] = useState<boolean>(false);
  const [modMode, setModMode] = useState<RegionGroup>(undefined);

  useEffect(() => {
    if (item) {
      if (item.region_group_seq === selectedRegion) {
        setAreaList(item.region);
      }
    }
  }, [item]);

  const handleModClick = async () => {
    await putRegionGroup(modMode.region_group_seq, modMode.name);
    refetch();
    setModMode(undefined);
  };

  const handleRegionDeleteClick = async (seq: number) => {
    await deleteRegionGroup(seq);
    refetch();
  };

  const handleDeleteClick = async (seq: number) => {
    await deleteRegion(seq);
    refetch();
  };
  return (
    <div className="listItem">
      {!modMode ? (
        <div
          className="li"
          style={item.region_group_seq === selectedRegion ? { background: 'rgba(50,50,180,0.2)' } : {}}
        >
          <Typography
            component="span"
            onClick={() => {
              setSelectedRegion(item.region_group_seq);
              setAreaList(item.region);
              setShow(!show);
            }}
          >
            {item.name + ' (' + item.region.length + ') '}
          </Typography>
          <Typography component="span" style={{ textAlign: 'right' }}>
            <EditIcon htmlColor="#999" onClick={() => setModMode(item)} />
            &nbsp;&nbsp;
            <DeleteIcon htmlColor="#999" onClick={() => handleRegionDeleteClick(item.region_group_seq)} />
          </Typography>
        </div>
      ) : (
        <div className="li" style={{ padding: '0 0.25rem' }}>
          <CustomTextField
            label="권역명"
            size="small"
            onChange={(e) => setModMode({ ...modMode, name: e.target.value })}
            value={modMode.name}
          />
          <Typography component="span" style={{ textAlign: 'right' }}>
            <DoneIcon htmlColor="#3F3" onClick={() => handleModClick()} />
          </Typography>
        </div>
      )}
      <Collapse in={show}>
        {item.region.map((sItem: Region, sIndex: number) => {
          return (
            <div key={sIndex} className="sub">
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <SubdirectoryArrowRightIcon htmlColor="#999" />
              </div>
              <div style={{ flexGrow: 1 }}>
                <Typography component="span">
                  {sItem.sido + ' ' + (sItem.sigugun !== null ? sItem.sigugun : '')}
                </Typography>
              </div>
              <div>
                <DeleteIcon htmlColor="#999" onClick={() => handleDeleteClick(sItem.seq)} />
              </div>
            </div>
          );
        })}
      </Collapse>
    </div>
  );
};
